<ng-container *transloco="let tloco; prefix: 'subscriptions.my-subscription'">
  <mat-card class="flex flex-col px-4 py-6 md:p-8">
    <div class="mb-2 flex gap-2">
      <img alt="" class="h-6 w-6 shrink-0" [src]="'icons/lightbulb.svg' | staticImageUrl" />
      <span class="text-heading-3">{{ tloco('features.title', { subName: subName }) }}</span>
    </div>
    <div class="flex flex-col gap-2">
      @for (feature of productFeatures; track feature; let i = $index) {
        <div class="flex gap-1" [class.hidden]="i > 2 && !showFeatures">
          <rma-icon glyph="done" theme="primary" />
          <span [innerHtml]="'subscriptions.card.features.' + feature.LanguageKey | transloco"></span>
        </div>
      }
    </div>
    <div class="mt-2 flex justify-end md:justify-start">
      <button type="button" class="text-blue-50!" (click)="showHideFeatures()" mat-button>{{ tloco(buttonText) }}</button>
    </div>
  </mat-card>
</ng-container>
